<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <p v-if="description">{{ description }}</p>
          <!-- <v-btn color="primary" @click="fetchSchedulingActivities">
            Refresh
          </v-btn> -->
        </v-col>
      </v-row>
      <v-row>
        <v-col v-for="item in schedulingActivities" :key="item.id" cols="12">
          <v-card class="audit-card">
            <div class="d-flex text-caption my-2 mx-4 justify-space-between">
              <span
                >By {{ item.updatedByFirstName }} {{ item.updatedByLastName }}
              </span>
              <v-divider vertical />
              <span>{{ item.updatedAt | formatDateTime }} </span>
            </div>
            <v-card-subtitle>
              <div>Action: {{ translateActionType(item.actionType) }}</div>
              <div class="d-flex justify-space-between">
                <span> {{ item.type }} </span>
                <span v-if="item.studentFirstName">
                  {{ item.studentFirstName }} {{ item.studentLastName }}
                </span>
                <span v-else-if="item.teacherFirstName">
                  {{ item.teacherFirstName }} {{ item.teacherLastName }}
                </span>
              </div>
            </v-card-subtitle>
            <v-card-text>
              <div class="d-flex justify-space-between">
                <span>Schedule ID:</span>
                <span>{{ item.entityId }}</span>
              </div>
              <div v-if="item.startDate" class="d-flex justify-space-between">
                <span>Date {{ item.recurring ? "(Recurring)" : "" }}:</span>
                <span>
                  {{ item.startDate | formatDate }} -
                  <span v-if="item.endDate">
                    {{ item.endDate | formatDate }}
                  </span>
                  <span v-else> N/A </span>
                </span>
              </div>
              <div v-if="item.startTime" class="d-flex justify-space-between">
                <span>Time:</span>
                <span>
                  {{ item.startTime | formatJustTime }} -
                  {{ item.endTime | formatJustTime }}
                </span>
              </div>

              <div class="my-4">Notes: {{ item.notes }}</div>
            </v-card-text>
            <v-card-actions>
              <div class="text-caption ml-auto mx-2">
                Audit record: {{ item.id }}
              </div>
            </v-card-actions>
          </v-card>
        </v-col>

        <v-btn
          class="mx-auto ma-4"
          color="primary"
          @click="fetchSchedulingActivities(currentPage + 1)"
          :disabled="isAllLoaded"
        >
          Load More
        </v-btn>
      </v-row>
    </v-container>
  </div>
</template>


<script>
import dialogMixin from "@/components/schedule/dialogMixin.js";
import moment from "moment";

export default {
  mixins: [dialogMixin],
  props: {
    teacherIds: {
      type: Array,
      required: false,
    },
    studentIds: {
      type: Array,
      required: false,
    },
    actionTypes: {
      type: Array,
      required: false,
    },
  },
  filters: {
    formatJustTime: function (timeString) {
      return moment(timeString, "HH:mm:ss").format("h:mm A");
    },
  },
  computed: {
    description() {
      let desc = "Displaying activities";
      if (this.dateRange.start) {
        desc += ` from ${this.$options.filters.formatDate(
          this.dateRange.start
        )}`;
      }
      if (this.dateRange.end) {
        desc += ` to ${this.$options.filters.formatDate(this.dateRange.end)}`;
      }
      return desc;
    },
  },
  data() {
    return {
      schedulingActivities: [],
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 0,
      isAllLoaded: false,
    };
  },
  created() {
    this.fetchSchedulingActivities(1);
  },
  methods: {
    async fetchSchedulingActivities(pageNumber = 1) {
      try {
        if (pageNumber === 1) {
          // Reset only when fetching the first page
          this.schedulingActivities = [];
          this.isAllLoaded = false;
        }

        const params = {
          startDate: moment(this.dateRange.start).format("YYYY-MM-DD"),
          endDate: moment(this.dateRange.end).format("YYYY-MM-DD"),
          teacherIds: this.teacherIds,
          studentIds: this.studentIds,
          actionTypes: this.actionTypes,
          page: pageNumber - 1,
          size: this.itemsPerPage,
          sort: "id,desc",
        };
        const response = await this.$axios.get("/scheduling-activities", {
          params,
        });
        this.schedulingActivities.push(...response.data.content);
        this.totalItems = response.data.totalElements;
        this.currentPage = pageNumber;

        // Update the all-loaded flag if all items are loaded
        if (this.schedulingActivities.length >= this.totalItems) {
          this.isAllLoaded = true;
        }
      } catch (error) {
        console.error(
          "An error occurred while fetching scheduling activities:",
          error
        );
      }
    },
    handlePagination(change) {
      this.currentPage = change.page;
      this.itemsPerPage = change.itemsPerPage;
      this.fetchSchedulingActivities();
    },
    translateActionType(actionType) {
      const translationMap = {
        EXCEPTION: "Canceled Schedule",
        UNDO_EXCEPTION: "Undo Canceled Schedule",
        ADD: "Added New Schedule",
        DELETED: "Deleted Schedule",
        UPDATED: "Updated Schedule",
      };
      return translationMap[actionType] || actionType;
    },
  },
  watch: {
    itemsPerPage: "fetchSchedulingActivities",
    currentPage: "fetchSchedulingActivities",
  },
};
</script>

<style>
.audit-card {
  margin-bottom: 20px;
  border: 1px solid #ccc;
}

.audit-card th,
.audit-card td {
  padding: 8px;
  text-align: left;
}
</style>
